export default __webpack_public_path__ + "static/media/readonlySupport.e3f2b97b.svg";